import { defineStore } from 'pinia'

export const useMessagesStore = defineStore('messages', {
  state: () => ({
    messages: []
  }),

  actions: {
    add(message, type = 'info', timeout = 5000) {
      const id = Date.now()

      this.messages.push({
        id,
        text: message,
        type,
        timeout
      })

      if (timeout) {
        setTimeout(() => {
          this.remove(id)
        }, timeout)
      }
    },

    remove(id) {
      const index = this.messages.findIndex(m => m.id === id)
      if (index > -1) {
        this.messages.splice(index, 1)
      }
    },

    success(message, timeout) {
      this.add(message, 'success', timeout)
    },

    error(message, timeout) {
      this.add(message, 'error', timeout)
    },

    warning(message, timeout) {
      this.add(message, 'warning', timeout)
    },

    info(message, timeout) {
      this.add(message, 'info', timeout)
    }
  }
})
